<template>
  <div class="flex justify-between items-center gap-6 flex-wrap">
    <div class="flex flex-col gap-4 flex-1">
      <template v-if="editMode">
        <FormKit id="name_input" v-model="inputName" type="text" outer-class="!m-0" />
        <FormKit id="description_input" v-model="inputDescription" type="textarea" outer-class="!m-0" />
      </template>
      <template v-else>
        <h1 class="block text-2xl font-bold leading-6 text-gray-900">{{ currentWorkflow.name }}</h1>
        <p class="text-sm text-gray-500">{{ currentWorkflow.description }}</p>
      </template>
      <div class="flex gap-2">
        <Badge variant="outline">{{ currentDefinition.trigger.name }}</Badge>
        <Badge v-if="hasActions" :variant="statusProperties.badgeVariant">{{ statusProperties.content }}</Badge>
        <Badge v-else variant="red">Missing Actions</Badge>
        <PersonalEmailUnverified v-if="!userStore.currentUser.postmarkEmailVerified" />
      </div>
    </div>
    <div v-if="editMode" class="flex gap-4">
      <Button @click="updateNameAndDescription">Save</Button>
      <Button variant="outline" @click="disableEditMode">Cancel</Button>
    </div>
    <div v-else class="flex gap-6">
      <Button variant="outline" @click="enableEditMode">Edit</Button>
      <div class="flex gap-2 items-center">
        {{ statusProperties.switch }}
        <Switch :model-value="isActive()" @update:model-value="handleToggle" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { useWorkflowStatus } from '../../useWorkflowStatus';
import { Switch } from '@/components/ui/switch';
import { useTitleBar } from './useTitleBar';
import { Button } from '@/components/ui/button';
import { FormKit } from '@formkit/vue';
import PersonalEmailUnverified from '@/components/shared/EmailBadge/PersonalEmailUnverified.vue';
import { useCurrentUserStore } from '@/stores/currentUser';

const userStore = useCurrentUserStore();

const currentWorkflowStore = useCurrentWorkflowStore();
const { currentWorkflow, currentDefinition } = currentWorkflowStore;

const handleToggle = async () => {
  const newStatus = await toggleStatus();
  if (newStatus) currentWorkflowStore.updateStatus(newStatus);
};

const { isActive, toggleStatus, statusProperties } = useWorkflowStatus(currentWorkflow);
const { editMode, inputName, inputDescription, hasActions, enableEditMode, disableEditMode, updateNameAndDescription } =
  useTitleBar();
</script>
